export const getLeadersOrganizationChartIS = {
	data: undefined,
	loading: false,
	error: null,
	errorShow: false,
};
